/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldstreet3Inputs */

const en_placewebfieldstreet3 = /** @type {(inputs: Placewebfieldstreet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const de_placewebfieldstreet3 = /** @type {(inputs: Placewebfieldstreet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Placewebfieldstreet3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldstreet3 = /** @type {((inputs?: Placewebfieldstreet3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldstreet3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldstreet3(inputs)
	return de_placewebfieldstreet3(inputs)
});
export { placewebfieldstreet3 as "placeWebFieldStreet" }